import { render } from "./AddFermPage.vue?vue&type=template&id=3fe5d5db&ts=true"
import script from "./AddFermPage.vue?vue&type=script&lang=ts"
export * from "./AddFermPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__